import { Typewriter } from 'react-simple-typewriter';

const TypingHeading = () => {
  return (
    <h3 className="text-4xl md:text-5xl font-bold mb-12 text-center ">
      <Typewriter
        words={['Hey there!', "I'm Bibhu", "I'm a developer", "I'm a programmer"]}
        loop={0} // 0 = infinite loop
        cursor
        cursorStyle="|"
        typeSpeed={80}
        deleteSpeed={50}
        delaySpeed={1500}
      />
    </h3>
  );
};

export default TypingHeading;
